export const PAGE_REPLACED_HEAD = 'pagemode-replaced-head';
export const PAGE_REPLACED_BODY = 'pagemode-replaced-body';

export const GLOBAL_KEY = '_LIGHTHUB';

export const LIGHTHUB_WRAN_PREFIX = 'LightHubWarn';

export const INTERNAL_LIGHTHUB_KEEP_ONCE = 'data-lighthub-keep-once';
export const INTERNAL_DATA_URL = 'data-lighthub-data-url';